// See more at https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

export const AiQueryKeys = {
    All: ["All"],
    GetCurrentUser: () => [...AiQueryKeys.All, "GetCurrentUser"],
    GetConversations: () => [...AiQueryKeys.All, "GetConversations"],
    GetSmartReport: () => [...AiQueryKeys.All, "GetSmartReport"],
    GetConversation: (conversationId: string) => [...AiQueryKeys.All, "GetConversation", { conversationId }],
    GetConversationFiles: (fileIds: string[]) => [...AiQueryKeys.All, "GetConversationFiles", { fileIds }],
    GetMembersByIds: (memberIds: string[]) => [...AiQueryKeys.All, "GetMembersByIds", { memberIds }],
    GetMemberCard: (memberId: string) => [...AiQueryKeys.All, "GetMemberCard", { memberId }],
    GetMemberCardByEmail: (memberEmail: string) => [...AiQueryKeys.All, "GetMemberCardByEmail", { memberEmail }],
    GetChannelsDetails: () => [...AiQueryKeys.All, "GetChannelsDetails"],
    GetPersonalization: () => [...AiQueryKeys.All, "GetPersonalization"],
    GetQuotaUsage: () => [...AiQueryKeys.All, "GetQuotaUsage"],
    GetMemberPrimaryTeam: () => [...AiQueryKeys.All, "GetMemberPrimaryTeam"],
    GetSkills: () => [...AiQueryKeys.All, "GetSkills"]
};

export const AiMutationKeys = {
    CreateConversation: () => ["CreateConversation"],
    CreateConversationMessage: () => ["CreateConversationMessage"],
    DeleteConversation: () => ["DeleteConversation"],
    UpdateConversationMessageRating: () => ["UpdateConversationMessageRating"],
    UpdateConversationMessageRatingExplanation: () => ["UpdateConversationMessageRatingExplanation"],
    GenerateFileUploadUrl: () => ["GenerateFileUploadUrl"],
    UploadFile: () => ["UploadFile"],
    DeleteFile: () => ["DeleteFile"],
    UpdatePersonalization: () => ["UpdatePersonalization"],
    UpdateSmartReport: () => ["UpdateSmartReport"]
};
